import React, { useEffect, useState } from "react";

import "./SIdebar.css";

// import Button from 'react-bootstrap/Button';
// import Offcanvas from 'react-bootstrap/Offcanvas';
import Logo from "../../images/logo.png";
import Logosm from "../../images/logo-sm.png";
import Menu from "../../images/menu-bar.png";
import manageIcon from '../../images/user-management.png'
import Billing from '../../images/billing.png'
import { Link } from "react-router-dom";

function Sidebaruser({handleToggle, isActive}) {
  

  return (
    <>
      <div className={isActive ? "isActive" : "sidebar"}>
        <div className="logo-menu">
          <div className="logo">
            <Link to="/">
              <img src={Logo} className="logo-lg" alt="" />
              <img src={Logosm} className="logo-sm" alt="" />{" "}
            </Link>
          </div>

          <div className="menubar" onClick={()=>handleToggle()}>
            <img src={Menu} alt="" />
          </div>
        </div>
        <div className="sidebaruser-menu">
          <ul className="userside-list">
            <li className="userlist-items">
              <Link className="user-link " to="/account"><div className="icon-use"><img src={manageIcon} alt="" /></div> <div className="text">Users Maanagement </div></Link>
            </li>
            <li className="userlist-items">
              <Link className="user-link user-active" to="/user"><div className="icon-use"><img src={Billing} alt="" /></div> <div className="text">Billing </div></Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Sidebaruser;
